var map = {
	"./basic.vue": "S0zI",
	"./clear.vue": "bKF4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "SSdR";


//////////////////
// WEBPACK FOOTER
// ./src/components/layouts nonrecursive .*\.vue$
// module id = SSdR
// module chunks = 22